import axios from 'axios'

const tiporegistro = {
    GetRegistros: () => axios.get(`tipo-registro/listar`),
    GetPaises: () => axios.get(`tipo-registro/get-paises`),
    PostRegistro: (datos) => axios.post(`tipo-registro/guardar`,(datos)),
    DeleteRegistro: ( id ) => axios.delete(`tipo-registro/${id}/eliminar`),
}
export default tiporegistro